module.exports = __webpack_public_path__ + "img/miniplant3.2722cb14.jpg";